module.exports = __webpack_public_path__ + "img/goods-2.0719389b.png";